import React from 'react';
import AbstractLayout from '../AbstractLayout';
import {Card, Col, Row} from 'reactstrap';
import Footer from './Footer';

export default class NonAuthLayout extends AbstractLayout {
    protected supportsBreadcrumbs = false;

    render() {
        return <div className="non-auth-layout">
            <Row className="justify-content-center">
                <Col md={8} lg={6} xl={5}>
                    <Card className="overflow-hidden">
                        {this.renderContent()}
                    </Card>

                    <Footer/>
                </Col>
            </Row>
        </div>;
    }
}
